import styled from 'styled-components';

export const APIWrapper = styled.div``;

export const LeftColumn = styled.div``;

export const RightColumn = styled.div``;
